import axios from 'axios'
import {
  loding
} from '../assets/js/utils.js'
import {
  Toast,
  Dialog
} from 'vant'
const service = axios.create({
  baseURL: process.env.BASE_API,
  // baseURL: "http://192.168.8.107:8080",
  timeout: 100000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
service.interceptors.request.use(config => {
  loding();
  return config
}, error => {
  Toast.clear();
  console.log(error) // for debug
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    Toast.clear();
    return response
  },
  error => {
    Toast.clear();
    console.log('err' + error) // for debug
    Dialog.alert({
      message: '哎呀，信息错误稍后重试',
    }).then(() => {
      window.history.go(-1)
    });
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js